import './style.scss';

/* ── Carousel Lazy Loading ────────────────────────────────────── */

( function () {
	const section = document.querySelector( '[data-carousel-lazy]' );
	if ( ! section ) return;

	function activate() {
		section.querySelectorAll( 'img[data-src]' ).forEach( function ( img ) {
			img.src = img.dataset.src;
			img.removeAttribute( 'data-src' );
		} );

		section.querySelectorAll( '.hwn-carousel-facade[data-vimeo]' ).forEach( function ( el ) {
			const id = el.dataset.vimeo;
			const iframe = document.createElement( 'iframe' );
			iframe.src = 'https://player.vimeo.com/video/' + id + '?background=1&autopause=0';
			iframe.setAttribute( 'frameborder', '0' );
			iframe.allow = 'autoplay';
			iframe.loading = 'lazy';
			el.appendChild( iframe );
		} );

		section.removeAttribute( 'data-carousel-lazy' );
	}

	if ( 'IntersectionObserver' in window ) {
		const observer = new IntersectionObserver( function ( entries ) {
			if ( entries[ 0 ].isIntersecting ) {
				activate();
				observer.disconnect();
			}
		}, { rootMargin: '200px' } );
		observer.observe( section );
	} else {
		activate();
	}
} )();

/* ── Mobile Menu ────────────────────────────────────────────── */

( function () {
	const toggle = document.querySelector( '.hwn-menu-toggle' );
	const menu = document.getElementById( 'mobile-menu' );
	if ( ! toggle || ! menu ) return;

	function openMenu() {
		menu.classList.add( 'hwn-mobile-menu--open' );
		toggle.classList.add( 'hwn-menu-toggle--open' );
		toggle.setAttribute( 'aria-expanded', 'true' );
		document.body.classList.add( 'hwn-menu-open' );
	}

	function closeMenu() {
		menu.classList.remove( 'hwn-mobile-menu--open' );
		toggle.classList.remove( 'hwn-menu-toggle--open' );
		toggle.setAttribute( 'aria-expanded', 'false' );
		document.body.classList.remove( 'hwn-menu-open' );
	}

	toggle.addEventListener( 'click', function () {
		menu.classList.contains( 'hwn-mobile-menu--open' ) ? closeMenu() : openMenu();
	} );

	menu.querySelectorAll( 'a' ).forEach( function ( link ) {
		link.addEventListener( 'click', closeMenu );
	} );

	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && menu.classList.contains( 'hwn-mobile-menu--open' ) ) {
			closeMenu();
		}
	} );

	window.addEventListener( 'resize', function () {
		if ( window.innerWidth > 900 && menu.classList.contains( 'hwn-mobile-menu--open' ) ) {
			closeMenu();
		}
	} );
} )();

/* ── Inquiry Modals ─────────────────────────────────────────── */

( function () {
	const cfg = typeof hwnInquiry !== 'undefined' ? hwnInquiry : null;
	if ( ! cfg ) return;

	let activeModal = null;

	function openModal( id ) {
		const modal = document.getElementById( 'modal-' + id );
		if ( ! modal ) return;

		const form = modal.querySelector( '.hwn-modal__form' );
		if ( form ) {
			form.reset();
			form.classList.remove( 'hwn-modal__form--loading' );
			form.querySelector( '.hwn-modal__error' ).textContent = '';
			form.querySelector( '[name="_opened"]' ).value = Math.floor( Date.now() / 1000 );
		}
		modal.querySelector( '.hwn-modal__success' ).hidden = true;
		if ( form ) form.style.display = '';

		modal.classList.add( 'hwn-modal--open' );
		modal.setAttribute( 'aria-hidden', 'false' );
		document.body.style.overflow = 'hidden';
		activeModal = modal;

		const firstInput = modal.querySelector( 'input[name="name"]' );
		if ( firstInput ) setTimeout( () => firstInput.focus(), 200 );
	}

	function closeModal() {
		if ( ! activeModal ) return;
		activeModal.classList.remove( 'hwn-modal--open' );
		activeModal.setAttribute( 'aria-hidden', 'true' );
		document.body.style.overflow = '';
		activeModal = null;
	}

	document.querySelectorAll( '[data-hwn-modal]' ).forEach( function ( btn ) {
		btn.addEventListener( 'click', function ( e ) {
			e.preventDefault();
			openModal( btn.dataset.hwnModal );
		} );
	} );

	document.querySelectorAll( '.hwn-modal__close' ).forEach( function ( btn ) {
		btn.addEventListener( 'click', closeModal );
	} );

	document.querySelectorAll( '.hwn-modal__backdrop' ).forEach( function ( el ) {
		el.addEventListener( 'click', closeModal );
	} );

	document.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' && activeModal ) closeModal();
	} );

	document.querySelectorAll( '.hwn-modal__form' ).forEach( function ( form ) {
		form.addEventListener( 'submit', async function ( e ) {
			e.preventDefault();

			const errorEl = form.querySelector( '.hwn-modal__error' );
			errorEl.textContent = '';
			form.classList.add( 'hwn-modal__form--loading' );

			const data = Object.fromEntries( new FormData( form ) );
			data.audience = form.dataset.audience;
			data._wpnonce = cfg.nonce;

			try {
				const res = await fetch( cfg.restUrl, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify( data ),
				} );

				const json = await res.json();

				if ( res.ok && res.status < 300 ) {
					form.style.display = 'none';
					const modal = form.closest( '.hwn-modal' );
					modal.querySelector( '.hwn-modal__success' ).hidden = false;

					setTimeout( closeModal, 3000 );
				} else {
					errorEl.textContent = json.message || 'Something went wrong. Please try again.';
				}
			} catch {
				errorEl.textContent = 'Network error. Please check your connection and try again.';
			} finally {
				form.classList.remove( 'hwn-modal__form--loading' );
			}
		} );
	} );
} )();
